export default __webpack_public_path__ + "backgroundSignAdmin.3b961ee.jpg";